import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useFavorites } from '../FavoritesContext';
import { useAuth } from '../AuthContext';

export default function FavoritesShortcut() {
    const { favorites } = useFavorites();
    const { isAuthenticated, checkAuth } = useAuth();
    const [isChecking, setIsChecking] = useState(true);
    const { pathname } = useLocation();
    const count = favorites.length;

    useEffect(() => {
        let active = true;
        checkAuth().finally(() => { if (active) setIsChecking(false); });
        return () => { active = false; };
    }, [checkAuth]);

    if (isChecking || isAuthenticated || count === 0) return null;

    return (
        <Link
            to="/preferiti"
            className="ef-favorites-shortcut bg-primary"
            aria-label={`Visualizza ${count} ${count === 1 ? 'preferito' : 'preferiti'}`}
            aria-current={pathname === '/preferiti' ? 'page' : undefined}
        >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z" />
            </svg>
            <span className="ef-favorites-shortcut__label">Preferiti</span>
            <span className="ef-favorites-shortcut__count" aria-hidden="true">{count}</span>
        </Link>
    );
}
